export function getDuration(start: string, end: string) {
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  const diff = endTime - startTime;

  const h = Math.floor(diff / 3600000);
  const hour = (h < 10 ? '0' : '') + h;
  const m = Math.floor((diff / 60000) % 60);
  const minute = (m < 10 ? '0' : '') + m;

  return `${hour}:${minute}`;
}

export function renderNiceDate(str: string) {
  const d = new Date(str);

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];

  const day = days[d.getDay()];
  const date = (d.getDate() < 10 ? '0' : '') + d.getDate();
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  const hour = (d.getHours() < 10 ? '0' : '') + d.getHours();
  const minute = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();

  return `${day}, ${date} ${month} ${year} at ${hour}:${minute} UTC+7`;
}

export default {
  getDuration,
  renderNiceDate,
};
